import React from 'react';
import classnames from 'classnames';
import { Spinner } from '../../shared/components/spinner';

export type ButtonVariant = 'primary' | 'secondary' | 'outline' | 'danger';
export type ButtonSize = 'sm' | 'md' | 'lg';
export type ButtonIconName = 'heart' | 'heart-filled';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode;
    variant?: ButtonVariant;
    size?: ButtonSize;
    isLoading?: boolean;
    className?: string;
    iconName?: ButtonIconName;
}

export default function Button({
    children,
    className = '',
    disabled = false,
    isLoading = false,
    variant = 'primary',
    iconName,
    ...props
}: ButtonProps) {
    return (
        <button
            type='button'
            className={classnames(className, 'bs-button-component', `bs-button-component--${variant}`, {
                [`bs-button-component--icon-${iconName}`]: !!iconName && !isLoading,
                'bs-button-component--loading': isLoading
            })}
            disabled={disabled}
            {...props}
        >
            {isLoading ? <Spinner /> : children}
        </button>
    );
}
